/*
 * Copyright © 2018-2025, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React, { ReactElement, useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";

interface Props {
  history: any[];
  icon: ReactElement;
  listFor: string;
}

export default function CustomHistoryList({ listFor, icon, history }: Props): ReactElement {
  const [historyList, setHistoryList] = useState(history);

  useEffect(() => setHistoryList(history), [history]);

  return (
    <div className="tw-card shadow divide-y divide-gray-200 dark:divide-gray-700">
      <div className="p-4 flex justify-between items-center space-x-3">
        <p className="font-semibold">{listFor}</p>
        <div className="relative rounded-full bg-sky-50 w-8 h-8 flex-shrink-0 flex justify-center items-center text-zinc-800 dark:bg-sky-50">
          {icon}
        </div>
      </div>
      <div className="p-4 flex flex-col space-y-4">
        {historyList.map((event, index) => (
          <div className="flex justify-between items-center space-x-3" key={index}>
            <p className="truncate">
              <strong>
                <Link
                  to={`/medical-record/${event.medicalRecordId}/latest`}
                  className="tw-link-dark"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {event.name}{" "}
                </Link>
              </strong>
            </p>
            <span className="text-gray-500 dark:text-gray-400 text-xs whitespace-nowrap">
              {moment(event.date).format("ll")}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
